import React, { useState, useEffect, useMemo, useRef } from "react";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/defaultV2.min.css";
import "./index.css";
import { Auth } from 'aws-amplify';
import { themeJson } from "./themejson";

import { useParams } from 'react-router-dom';

import { getUserSurveyFromAPI, updateUserSurveyFromAPI } from '../../../services/UserSurveyService';
import { updateSurveyResultFromAPI, completeSurveyResultFromAPI } from '../../../services/surveyResultService';
import { getQuestionsFromAPI } from '../../../services/questionService';

function UserSurveyComponent() {

    const { user_survey_id } = useParams();
    console.log('user_survey_id:', user_survey_id);

    const [userSurvey, setUserSurvey] = useState([]);
    const userSurveyRef = useRef(userSurvey);
    const [page404, setPage404] = useState(null);
    const [surveyJson, setSurveyJson] = useState({});
    const surveyJsonRef = useRef(surveyJson);
    const intervalRef = useRef(null);

    let survey = useMemo(() => new Model(surveyJson), [surveyJson]);
    survey.applyTheme(themeJson);
    survey.propertyHash.showTOC = false;

    useEffect(() => {
        userSurveyRef.current = userSurvey; // State her değiştiğinde ref'i güncelle
    }, [userSurvey]);

    useEffect(() => {
        surveyJsonRef.current = surveyJson; // State her değiştiğinde ref'i güncelle
    }, [surveyJson]);

    function getQuestionName(questions, question_id) {
        return questions.find(q => q.ID == question_id).question;
    }

    function arrangeSurveyContent(questions, element) {
        if (element.type == 'panel') {
            element.elements.forEach(subElement => {
                arrangeSurveyContent(questions, subElement);
            });
        } else if (element.type == 'matrix') {
            element.rows.forEach(row => {
                row.text = getQuestionName(questions, row.value);
            });
        } else if (element.type == 'radiogroup') {
            element.title = getQuestionName(questions, element.name);
        } else if (element.type == 'text') {
            element.title = getQuestionName(questions, element.name);
        } else if (element.type == 'dropdown') {
            element.title = getQuestionName(questions, element.name);
        }
        return element;
    }

    async function getUserSurvey() {
        try {
            let result = await getUserSurveyFromAPI(user_survey_id);
            console.log('usersurveys result:', result);
            // await getQuestionsFromAPI("").then((questions) => {

            // result["survey"].survey_content.pages.forEach(page => {
            //     page.elements.forEach(element => {
            //         element = arrangeSurveyContent(result["questions"], element);
            //     });   
            // })

            setUserSurvey(result["survey"]);
            setSurveyJson(result["survey"].survey_content);
            setPage404(false);
            // });        
        } catch (error) {
            console.log('error:', error);
            setPage404(true)
        }
    }

    const updateTOCVisibility = (survey) => {
        if (survey && survey.propertyHash) {
            const isFirstPage = survey.currentPageNo === 0;
            survey.propertyHash.showTOC = !isFirstPage;
        }
    };

    async function sendAnswers(surveySenderData) {
        updateUserSurveyFromAPI(userSurveyRef.current.ID, surveySenderData).then((result) => {
            console.log('on value changed result : ', result);
        }).catch((error) => {
            console.log('on value changed error : ', error);
        });

        let _answers = [];
        for (var key in surveySenderData.answers) {
            let _answer = {}
            const _pages = surveyJsonRef.current.pages.filter(page => page.name !== "intro");
            for (var i = 0; i < _pages.length; i++) {
                _answer["section"] = _pages[i].title;
                for (var j = 0; j < _pages[i].elements[0].elements.length; j++) {
                    if (_pages[i].elements[0].elements[j].type === "html") {
                        _answer["page"] = _pages[i].elements[0].elements[j].name;
                    } else if (_pages[i].elements[0].elements[j].elements[0].name === key) {
                        _answer["question_id"] = key;
                        _answer["question"] = _pages[i].elements[0].elements[j].elements[0].title;
                        _answer["type"] = _pages[i].elements[0].elements[j].elements[0].type;
                        _answer["weight"] = _pages[i].elements[0].elements[j].elements[0].weight || 1.0;
                        if (_pages[i].elements[0].elements[j].elements[0].type === "rating") {
                            _answer["rateCount"] = _pages[i].elements[0].elements[j].elements[0].rateCount;
                        }
                        if (_pages[i].elements[0].elements[j].elements[0].type === "radiogroup" || _pages[i].elements[0].elements[j].elements[0].type === "dropdown") {
                            _answer["answer"] = _pages[i].elements[0].elements[j].elements[0].choices.find(choice => choice.value === surveySenderData.answers[key]).text;
                            if (_pages[i].elements[0].elements[j].elements[0].choices.find(choice => choice.value === surveySenderData.answers[key]).weight !== undefined) {
                                _answer["optionWeight"] = parseFloat(_pages[i].elements[0].elements[j].elements[0].choices.find(choice => choice.value === surveySenderData.answers[key]).weight);
                            }
                            _answer["options"] = _pages[i].elements[0].elements[j].elements[0].choices.map(choice => choice.text);
                        } else if (_pages[i].elements[0].elements[j].elements[0].type === "checkbox" || _pages[i].elements[0].elements[j].elements[0].type === "tagbox"
                            || _pages[i].elements[0].elements[j].elements[0].type === "ranking") {
                            _answer["answer"] = [];
                            for (var k = 0; k < surveySenderData.answers[key].length; k++) {
                                if (_pages[i].elements[0].elements[j].elements[0].choices.find(choice => choice.value === surveySenderData.answers[key][k])) {
                                    _answer["answer"].push(_pages[i].elements[0].elements[j].elements[0].choices.find(choice => choice.value === surveySenderData.answers[key][k]).text);
                                } else if (surveySenderData.answers[key][k] === 'other') {
                                    _answer["answer"].push(surveySenderData.answers[key + '-Comment']);
                                } else {
                                    _answer["answer"].push(surveySenderData.answers[key][k]);
                                }
                            }
                            _answer["options"] = _pages[i].elements[0].elements[j].elements[0].choices.map(choice => choice.text);
                        } else {
                            _answer["answer"] = surveySenderData.answers[key];
                        }
                        _answers.push(_answer);
                        j = _pages[i].elements[0].elements.length;
                        i = _pages.length - 1;
                    }
                }
            }
        }

        updateSurveyResult(_answers);
    }

    useEffect(() => {
        getUserSurvey();
        localStorage.setItem("surveySenderData", JSON.stringify({}));
        localStorage.setItem("lastSendedSurveySenderData", JSON.stringify({}));

        intervalRef.current = setInterval(() => {
            const surveySenderData = localStorage.getItem("surveySenderData");
            const lastSendedSurveySenderData = localStorage.getItem("lastSendedSurveySenderData");
            if (surveySenderData !== lastSendedSurveySenderData) {
                sendAnswers(JSON.parse(surveySenderData));
                localStorage.setItem("lastSendedSurveySenderData", surveySenderData);
            }
        }, 10000);

        return () => clearInterval(intervalRef.current); // Bileşen unmount olduğunda temizle
    }, []);

    const stopInterval = () => {
        clearInterval(intervalRef.current); // ✅ Interval’i durdur
        console.log("Interval durduruldu!");
    };

    useEffect(() => {

        // updateTOCVisibility(survey);
        survey.onCurrentPageChanged.add(function (survey, options) {
            // updateTOCVisibility(survey);
            const currentPage = survey.currentPage;

            if (currentPage) {
                var jsonObj = currentPage.elements[0].jsonObj.elements
                const subtitleElements = jsonObj.filter(element => element.type === "html").map(element => element.name);
                const elementsArray = Array.isArray(subtitleElements) ? subtitleElements : Array.from(subtitleElements);
                setTimeout(() => {
                    const tocList = document.querySelector('.sv-list');
                    if (tocList) {
                        tocList.innerHTML = '';
                        elementsArray.forEach(name => {
                            const listItem = document.createElement('li');
                            listItem.className = 'sv-list__item';
                            listItem.role = 'option';
                            listItem.setAttribute('aria-selected', 'false');
                            listItem.tabIndex = 0;

                            const listItemBody = document.createElement('div');
                            listItemBody.className = 'sv-list__item-body';
                            listItemBody.title = name;
                            listItemBody.style.paddingInlineStart = '16px';

                            const span = document.createElement('span');
                            span.className = 'sv-string-viewer';
                            span.textContent = name;

                            listItemBody.appendChild(span);
                            listItem.appendChild(listItemBody);
                            tocList.appendChild(listItem);
                        });
                    }
                }, 0);
            }

        });
        survey.onProgressText.add(function (survey, options) {
            const currentPage = survey.currentPage;
            let totalQuestions = 0;
            let answeredQuestions = 0;

            if (currentPage) {
                totalQuestions = currentPage.questions.length;
                currentPage.questions.forEach(function (question) {
                    if (question.isAnswered) {
                        answeredQuestions++;
                    }
                });
                const pageTitle = currentPage.name || "Page";

                options.text = `${pageTitle} - Answered Questions: ${answeredQuestions}/${totalQuestions}`;

            }
        });

        survey.onComplete.add((sender, options) => {
            stopInterval();
            sendAnswers(JSON.parse(localStorage.getItem("surveySenderData")));
            completeSurvey();
        });

        survey.onValueChanged.add(function (sender) {
            const obj = {
                answers: sender.data,
                is_started: true,
                current_page: sender.currentPageNo
            }
            console.log('onValueChanged obj:', obj);
            localStorage.setItem("surveySenderData", JSON.stringify(obj));
        });

        survey.onStarted.add(function (sender) {
            if (userSurvey.answers && Object.keys(userSurvey.answers).length > 0) {
                survey.data = userSurvey.answers;
                survey.currentPageNo = userSurvey.current_page;
            }
        });

        // survey.onCurrentPageChanged.add((sender) => {
        //     if (!surveyStarted && sender.currentPageNo === 0) {
        //         setSurveyStarted(true);

        //         if (userSurvey.answers && Object.keys(userSurvey.answers).length > 0) {
        //             survey.data = userSurvey.answers;
        //             survey.currentPageNo = userSurvey.current_page;
        //         }
        //     } else if (surveyStarted || userSurvey.survey_content.firstPageIsStarted) {
        //         const obj = {
        //             answers: survey.data,
        //             is_started: true,
        //             current_page: sender.currentPageNo
        //         }
        //         updateUserSurveyFromAPI(userSurvey.ID, obj).then((result) => {
        //             console.log('update user survey result : ', result);
        //         }).catch((error) => {
        //             console.log('on current page changed error : ', error);
        //             // if (error.response.status == 404) {
        //             //     setPage404(true);
        //             // }
        //         });
        //     }
        // });
    })

    async function updateSurveyResult(surveyAnswers) {
        try {
            let obj = {
                user_survey_id: userSurveyRef.current.ID,
                user_id: userSurveyRef.current.user_id,
                survey_id: userSurveyRef.current.survey_id,
                answers: surveyAnswers
            }
            // console.log('updateSurveyResultFromAPI obj:', obj);
            await updateSurveyResultFromAPI(obj).then((result) => {
                console.log('add surveyresult result : ', result);
            }).catch((error) => {
                // console.log('add surveyresult error : ', error);
                // if (error.response.status == 404) {
                //     setPage404(true);
                // }
            });
        }
        catch (error) {
            console.log('update user survey error : ', error);
        }
    }

    async function completeSurvey() {
        try {
            let obj = {
                user_survey_id: userSurvey.ID,
                survey_id: userSurvey.survey_id
            }

            await completeSurveyResultFromAPI(obj).then((result) => {
                console.log('complete survey result : ', result);
            }).catch((error) => {
                console.log('complete survey error : ', error);
                // if (error.response.status == 404) {
                //     setPage404(true);
                // }
            });
        }
        catch (error) {
            console.log('update user survey error : ', error);
        }
    }

    return (
        <div className="survey-container">
            {page404 && <div>404</div>}
            {/* {!page404 && <div> 
                Survey Gelecek <br />
            user_survey_id id : {user_survey_id} <br />
                </div>} */}
            {page404 == false && !userSurvey.is_completed && <Survey model={survey} />}
            {page404 == false && userSurvey.is_completed && (
                <div>
                    <h1>You already complete this survey!</h1>
                </div>
            )}
        </div>
    );
}

export default UserSurveyComponent;